import { h } from "preact";
import { observer } from "mobx-react";
import CartFooterActions from "./CartFooterActions";
function CartFooter(props) {
    return (h("div", { class: "modal-footer modal-footer--sticky" },
        h(CartFooterActions, { ...props })));
}
export default observer(CartFooter);
